import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpHeadersService } from 'src/app/core/shared-service/http-headers.service';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { CommonUtil } from 'src/app/core/Utils/common-util';

@Injectable({
  providedIn: 'root'
})
export class WorkoutService {

  constructor(
    private http: HttpClient,
    private header: HttpHeadersService,
    private commonUtil: CommonUtil,
  ) {
  }

  async getWorkoutTemplates(activityId: string, consoleType: string, facilityIds: string[]) {
    const headers = this.header.bearerHttpAuthorizationHeader();
    let payload = { activityId: activityId, consoleType: consoleType, facilityIds: facilityIds };
    let result = await this.http.post(`${environment.servicePath}/custom_workouts/get_custom_workout_templates`, payload, { headers }).toPromise();
    let preparedWorkoutDetailsList = this.prepareWorkoutTemplate(result,consoleType);
    return preparedWorkoutDetailsList;
  }

  public prepareWorkoutTemplate(data: any, consoleType: string) {
    if (!data) return data;
    let workoutBundleList = data.customWorkoutBundlesList;
    workoutBundleList.forEach((list: any) => {
      list.hasWorkoutChanged = false;
      list.totalWorkouts = 0;
      if(list.customWorkoutBundleDetails){
        list.totalWorkouts += list.customWorkoutBundleDetails.length;
        for (let i = list.customWorkoutBundleDetails.length; i < 8; i++) {
          list.customWorkoutBundleDetails.push(
            {
              activityId: '', bundleId: '', createdAt: '',
              facilityWorkoutId: '', orderId: '', updatedAt: '', workoutCreatedAt: '', workoutDefName: ''
              , workoutId: (i + 1).toString(), workoutName: '', workoutParamList: [], workoutUnit: '', workoutUpdatedAt: ''
            } as any);
        }
      }
      if(consoleType === 'discover'){
        if(list.classicCustomWorkoutsList){
          list.totalWorkouts += list.classicCustomWorkoutsList.length;
          for (let i = list.classicCustomWorkoutsList.length; i < 3; i++) {
            list.classicCustomWorkoutsList.push(
              {
                activityId: '', bundleId: '', createdAt: '',
                facilityWorkoutId: '', orderId: '', updatedAt: '', workoutCreatedAt: '', workoutDefName: ''
                , workoutId: (i + 1).toString(), workoutName: '', workoutParamList: [], workoutUnit: '', workoutUpdatedAt: ''
              } as any);
          }
        }else{
          list.classicCustomWorkoutsList = [{
            activityId: '', bundleId: '', createdAt: '',
            facilityWorkoutId: '', orderId: '', updatedAt: '', workoutCreatedAt: '', workoutDefName: ''
            , workoutId: '1', workoutName: '', workoutParamList: [], workoutUnit: '', workoutUpdatedAt: ''
          },{
            activityId: '', bundleId: '', createdAt: '',
            facilityWorkoutId: '', orderId: '', updatedAt: '', workoutCreatedAt: '', workoutDefName: ''
            , workoutId: '2', workoutName: '', workoutParamList: [], workoutUnit: '', workoutUpdatedAt: ''
          },{
            activityId: '', bundleId: '', createdAt: '',
            facilityWorkoutId: '', orderId: '', updatedAt: '', workoutCreatedAt: '', workoutDefName: ''
            , workoutId: '3', workoutName: '', workoutParamList: [], workoutUnit: '', workoutUpdatedAt: ''
          }]
        }
        
        if(list.healthyHeartCustomWorkoutsList){
          list.totalWorkouts += list.healthyHeartCustomWorkoutsList.length;
          for (let i = list.healthyHeartCustomWorkoutsList.length; i < 3; i++) {
            list.healthyHeartCustomWorkoutsList.push(
              {
                activityId: '', bundleId: '', createdAt: '',
                facilityWorkoutId: '', orderId: '', updatedAt: '', workoutCreatedAt: '', workoutDefName: ''
                , workoutId: (i + 1).toString(), workoutName: '', workoutParamList: [], workoutUnit: '', workoutUpdatedAt: ''
              } as any);
          }
        }else{
          list.healthyHeartCustomWorkoutsList = [{
            activityId: '', bundleId: '', createdAt: '',
            facilityWorkoutId: '', orderId: '', updatedAt: '', workoutCreatedAt: '', workoutDefName: ''
            , workoutId: '1', workoutName: '', workoutParamList: [], workoutUnit: '', workoutUpdatedAt: ''
          },{
            activityId: '', bundleId: '', createdAt: '',
            facilityWorkoutId: '', orderId: '', updatedAt: '', workoutCreatedAt: '', workoutDefName: ''
            , workoutId: '2', workoutName: '', workoutParamList: [], workoutUnit: '', workoutUpdatedAt: ''
          },{
            activityId: '', bundleId: '', createdAt: '',
            facilityWorkoutId: '', orderId: '', updatedAt: '', workoutCreatedAt: '', workoutDefName: ''
            , workoutId: '3', workoutName: '', workoutParamList: [], workoutUnit: '', workoutUpdatedAt: ''
          }]
        }
  
        if(list.performanceCustomWorkoutsList){
          list.totalWorkouts += list.performanceCustomWorkoutsList.length;
          for (let i = list.performanceCustomWorkoutsList.length; i < 3; i++) {
            list.performanceCustomWorkoutsList.push(
              {
                activityId: '', bundleId: '', createdAt: '',
                facilityWorkoutId: '', orderId: '', updatedAt: '', workoutCreatedAt: '', workoutDefName: ''
                , workoutId: (i + 1).toString(), workoutName: '', workoutParamList: [], workoutUnit: '', workoutUpdatedAt: ''
              } as any);
          }
        }else{
          list.performanceCustomWorkoutsList = [{
            activityId: '', bundleId: '', createdAt: '',
            facilityWorkoutId: '', orderId: '', updatedAt: '', workoutCreatedAt: '', workoutDefName: ''
            , workoutId: '1', workoutName: '', workoutParamList: [], workoutUnit: '', workoutUpdatedAt: ''
          },{
            activityId: '', bundleId: '', createdAt: '',
            facilityWorkoutId: '', orderId: '', updatedAt: '', workoutCreatedAt: '', workoutDefName: ''
            , workoutId: '2', workoutName: '', workoutParamList: [], workoutUnit: '', workoutUpdatedAt: ''
          },{
            activityId: '', bundleId: '', createdAt: '',
            facilityWorkoutId: '', orderId: '', updatedAt: '', workoutCreatedAt: '', workoutDefName: ''
            , workoutId: '3', workoutName: '', workoutParamList: [], workoutUnit: '', workoutUpdatedAt: ''
          }]
        }
      }         
    });
    return workoutBundleList;
  }

  getWorkoutLibrary(activityId: string, categoryId: string, consoleType: string, facilityIds: string[]) {
    const headers = this.header.bearerHttpAuthorizationHeader();
    let payload = { activityId: activityId, categoryId: categoryId, consoleType: consoleType, facilityIds: facilityIds };
    let result = this.http.post(`${environment.servicePath}/custom_workouts/get_custom_workout_library`, payload, { headers });
    return result as Observable<any>;
  }

  getWorkoutsByActivity(activityId: number, categoryId: string, consoleType: string) {
    let headers = this.header.bearerHttpAuthorizationHeader();
    const result = this.http.get(`${environment.servicePath}/custom_workouts/get_workouts_by_activity?activityId=${activityId}&categoryId=${categoryId}&consoleType=${consoleType}&temp=${+Math.random()}`, { headers });
    return result as Observable<any>;
  }

  getCardioParamDef(activityId: number, workoutId: string, consoleType: string, facilityId: string) {
    let headers = this.header.bearerHttpAuthorizationHeader();
    return this.http.get(`${environment.servicePath}/custom_workouts/get_cardio_param_def?activityId=${activityId}&workoutId=${workoutId}&consoleType=${consoleType}&facilityId=${facilityId}`, { headers }).toPromise();;
  }

  saveWorkOutTemplates(payload:any) {
    const headers = this.header.bearerHttpAuthorizationHeader(); 
    return this.http.post(`${environment.servicePath}/custom_workouts/save_custom_workout_templates`, payload, { headers }).toPromise();
  }

  saveWorkOut(payload:any){
    const headers = this.header.bearerHttpAuthorizationHeader();
    return this.http.post(`${environment.servicePath}/custom_workouts/save_custom_workout`, payload, { headers }).toPromise();    
  }

  deleteWorkoutFromLib(workoutId:string){
    const headers = this.header.bearerHttpAuthorizationHeader();
    return this.http.delete(`${environment.servicePath}/custom_workouts/delete_custom_workout?customWorkoutId=${workoutId}`, { headers }).toPromise(); 
 }

 deleteWorkoutTemplate(bundleId:string){
  const headers = this.header.bearerHttpAuthorizationHeader();
  return this.http.delete(`${environment.servicePath}/custom_workouts/delete_custom_workout_template?bundleId=${bundleId}`, { headers }).toPromise(); 
}

  publishWorkoutTemplates(payload:any) {
    const headers = this.header.bearerHttpAuthorizationHeader();
    return this.http.post(`${environment.servicePath}/custom_workouts/publish_custom_workout_template`, payload, { headers }).toPromise();
  }

  getEquipmentDisplayNameByEquipmentTypeId(activityId: number) {
    if (activityId == 2 || activityId == 3 || activityId == 203) {
      return this.commonUtil.translateText('LIFECYCLE.EXERCISE.BIKE');
    } else if (activityId == 1) {
      return this.commonUtil.translateText('TREADMILL');
    } else if (activityId == 15) {
      return this.commonUtil.translateText('FLEXSTRIDER.VARIABLE.STRIDE.TRAINER');
    } else if (activityId == 16) {
      return this.commonUtil.translateText('POWERMILL.CLIMBER');
    } else if (activityId == 4) {
      return this.commonUtil.translateText('ELLIPTICAL.CROSS.TRAINER');
    } else if (activityId == 18) {
      return this.commonUtil.translateText('GSC.TRAINER');
    } else if (activityId == 19) {
      return this.commonUtil.translateText('ARC.TRAINER');
    } else if (activityId == 28) {
      return this.commonUtil.translateText('PERFORMANCE.TREADMILL');
    }
  }
}
